'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkValuePropStrip.module.css';

export function DevlinkValuePropStrip({ as: _Component = _Builtin.Section }) {
  return (
    <_Component
      grid={{
        type: 'section',
      }}
      tag="div"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'ht-value-prop-group')} tag="div">
          <_Builtin.Block
            className={_utils.cx(_styles, 'ht-value-prop-item')}
            id={_utils.cx(_styles, 'w-node-_647c80d0-e3be-a4c1-0124-ee8bb232bcaf-b232bcac')}
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, 'ht-value-prop-img')}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/65f4993f4acc8a860ca05cde_clock.svg"
            />
            <_Builtin.Block className={_utils.cx(_styles, 'ht-value-prop-text')} tag="div">
              {'Service as soon as today'}
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'ht-value-prop-item')} tag="div">
            <_Builtin.Image
              className={_utils.cx(_styles, 'ht-value-prop-img')}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/65f4993f2d798b8658c471a0_tool.svg"
            />
            <_Builtin.Block className={_utils.cx(_styles, 'ht-value-prop-text')} tag="div">
              {'Expert technicians nationwide'}
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'ht-value-prop-item')} tag="div">
            <_Builtin.Image
              className={_utils.cx(_styles, 'ht-value-prop-img')}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/65f4993f4f142a4a1441be21_check-circle-outline.svg"
            />
            <_Builtin.Block className={_utils.cx(_styles, 'ht-value-prop-text')} tag="div">
              {'Don’t pay until the job is done'}
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'ht-value-prop-item')} tag="div">
            <_Builtin.Image
              className={_utils.cx(_styles, 'ht-value-prop-img')}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/65f4993fb553fca0ec4bda9e_star-outline.svg"
            />
            <_Builtin.Block className={_utils.cx(_styles, 'ht-value-prop-text')} tag="div">
              {'100% satisfaction guaranteed'}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
